// extracted by mini-css-extract-plugin
export var btn = "K_mz q_rt q_rc d_by d_bN d_bC d_dv";
export var full = "K_wr d_v d_G";